import React, { Component } from "react"
import ReactDOM from "react-dom"
import styled from "styled-components"
import {media} from "utils/Media"
import { TimelineMax } from "gsap"
import Swipe from 'react-easy-swipe'

const ButtonSwipeWrap = styled.div`
    position: absolute;
    z-index: 19;
    bottom: 2.75rem;
    left: 50%;
    transform: translateX(-50%) scale(0.80);
    
    @media ${media.sm} {
      bottom: 3rem;
    }
    
    @media ${media.lg} {
        bottom: 6rem;
    }
    
    @media ${media.disney} {
        transform: translateX(-50%) scale(1);
    }
`

const ButtonWrap = styled.div`
    position: relative;
`
const ButtonBar = styled.div`
    width: 250px;
    height: 15px;
    /* background-color: rgba(255, 255, 255, .8); */
    background-image: linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
    border-radius: 10px;
    
    
`

const ButtonCircleWrap = styled.div`
    width: 40px;
    height: 40px;
    position: absolute;
    left: 30%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
`

const ButtonCircle = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    opacity: 0;
    user-select: none;
    pointer-events: none;
`

const ButtonCircleText = styled.div`
    user-select: none;
    pointer-events: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    font-family: ${props => props.theme.font.family.bold};
    font-size: 1.15rem;
    text-align: center;
`

const ButtonSwipeTrigger = styled.div`
    cursor: pointer;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
    height: 100px;
    z-index: 1;
`

class ButtonSwipe extends Component {
    constructor(props) {
        super(props)

        this.state = {
            toggled: false
        }

        this.masterTimeline = new TimelineMax({ paused: true })
        this.buttonCircleWrapTimeline = new TimelineMax()

        this.toggle = this.toggle.bind(this)
        this.animate = this.animate.bind(this)
    }


    componentDidMount() {
        // create animation
        this.initialAnimation()
    }

    componentDidUpdate() {
        if (this.props.play) {
            // play animation
            this.masterTimeline.play()
        }
    }

    componentWillUnmount() {
        // Kill on unmount
        this.masterTimeline.kill()
    }

    initialAnimation() {
        const buttonCircleTimeline = new TimelineMax()
        const buttonCircleTextTimeline = new TimelineMax()

        buttonCircleTimeline
            .to(this.buttonCircle, .4, { width: "100px", height: "100px", opacity: .8, delay: 0.2 })
            .to(this.buttonCircle, .2, { width: "90px", height: "90px", opacity: 1 })
            .to(this.buttonCircle, .3, { width: "100px", height: "100px", delay: 0.5 })
            .to(this.buttonCircle, .3, { width: "90px", height: "90px" })

        buttonCircleTextTimeline
            .to(this.buttonCircleText, .4, { opacity: 1, delay: 0.5 })

        this.masterTimeline
            .add([buttonCircleTimeline, buttonCircleTextTimeline])
    }

    animate(toggled) {
        let left = "30%"
        let bgImage = "linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))"
        if (toggled) {
            left = "70%"
            bgImage = "linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))"
        }

        const buttonBarTimeline = new TimelineMax()

        this.buttonCircleWrapTimeline
            .to(this.buttonCircleWrap, .4, { left: left })

        buttonBarTimeline
            .to(this.buttonBar, .6, { backgroundImage: `${bgImage}` })
    }

    toggle(direction) {


        const node = ReactDOM.findDOMNode(this.props.target);

        if (direction === "right") {
           // Show
            
            if (node) {
                node.classList.add('active')
            }
            if (this.props.callback){
                this.props.callback(true)
            }
            this.animate(true)
        } else {
            // Hide
            
            if (node) {
                node.classList.remove('active')
            }
            if (this.props.callback){
                this.props.callback(false)
            }
            this.animate(false)
        }

    }

    render() {
        return (
            <ButtonSwipeWrap>
                <ButtonWrap>
                    <ButtonBar ref={buttonBar => this.buttonBar = buttonBar} />
                    <ButtonCircleWrap ref={buttonCircleWrap => this.buttonCircleWrap = buttonCircleWrap}>
                        <ButtonCircle ref={buttonCircle => this.buttonCircle = buttonCircle} />
                        <ButtonCircleText ref={buttonCircleText => this.buttonCircleText = buttonCircleText}>swipe</ButtonCircleText>
                    </ButtonCircleWrap>
                </ButtonWrap>
                <Swipe
                    onSwipeLeft={() => this.toggle('left')}
                    onSwipeRight={() => this.toggle('right')}
                    allowMouseEvents={true}
                >
                    <ButtonSwipeTrigger />
                </Swipe>
            </ButtonSwipeWrap>
        )
    }
}

export default ButtonSwipe